module.exports = __webpack_public_path__ + "static/media/img-3.a888f92c.jpg";